// Obvious junk/test records left over from development. Matching an address here
// only HIDES it from reports — nothing is deleted from the database.
export const looksLikeJunk = (s) => {
  const v = String(s || "").toLowerCase();
  if (v.includes("smoke test") || v.includes("smoek tesdt")) return true;
  // Whole word "test" — catches "123 test street" / "123 TEST ST SMOKE" while
  // real streets ("Testman Ave", "Smokey Hollow Rd") never match: "test" must
  // stand alone as its own word.
  return /\btest\b/.test(v);
};
